module.exports = __webpack_public_path__ + "static/img/13.edf9fed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/13.png
// module id = QpTV
// module chunks = 0